import { colSize_t, offsetSize_t, tabletColSize_t } from '../../UI/Grid';
import {
    PrismicTitleFieldType,
    PrismicRichTextFieldType,
    FluidGatsbyImageFieldType,
    PrismicLinkFieldType,
    SliceContext,
} from '../types';

export enum Positions {
    Left = 'Left',
    Right = 'Right',
    Center = 'Center',
}

export type PositionsStyles = {
    flexDirection: string;
    leftColSize: colSize_t;
    leftColOffset: offsetSize_t;
    rightColSize: colSize_t;
    rightColOffset: offsetSize_t;
    r_tabletColSize: tabletColSize_t;
};

export type FeatureProps = {
    slice: {
        slice_type: string;
        primary: {
            feature_title: PrismicTitleFieldType;
            feature_position: Positions;
            feature_description: PrismicRichTextFieldType;
            feature_cta_label: PrismicTitleFieldType;
            feature_cta_link: PrismicLinkFieldType;
            feature_image: FluidGatsbyImageFieldType;
        };
    };
    sliceContext: SliceContext;
};
